module.exports = __webpack_public_path__ + "img/bump-map.b9832a7e.gif";